<mat-nav-list class="sidenav-list sidenav-buttons">
  <div class="full-width f-end">
    <button cdkFocusInitial class="close-btn" [disableRipple]="true" mat-flat-button (click)="onSidenavClose()">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <span></span>

  <div class="user-menu" *ngIf="isLoged">
    <div routerLinkActive="active" class="full-width">
      <button class="upercase lr-space bt-links" mat-flat-button>
        <mat-icon class="user-icon">person_outline</mat-icon> HOLA {{ userObject?.firstName | uppercase }}
      </button>
    </div>
  </div>

  <div routerLinkActive="active" class="full-width">
    <button (click)="onSidenavClose()" class="upercase lr-space bt-links" mat-flat-button [routerLink]="['/home']">
      INICIO
    </button>
  </div>
  <div routerLinkActive="active" class="full-width">
    <button (click)="onSidenavClose()" class="upercase lr-space bt-links" mat-flat-button
      (click)="clickScroll('about')">
      ¿QUÉ ES BITCAR?
    </button>
  </div>
  <div routerLinkActive="active" class="full-width">
    <button (click)="onSidenavClose()" class="upercase lr-space bt-links" mat-flat-button (click)="clickScroll('how')">
      ¿CÓMO FUNCIONA?
    </button>
  </div>
  <div routerLinkActive="active" class="full-width">
    <button (click)="onSidenavClose()" class="upercase lr-space bt-links" mat-flat-button [routerLink]="['/planes']">
      PLANES
    </button>
  </div>
  <div routerLinkActive="active" class="full-width">
    <a (click)="onSidenavClose()" class="upercase lr-space bt-links" mat-flat-button href="https://blog.bitcar.mx/"
      target="_blank" rel="noopener">
      BLOG
    </a>
  </div>
  <div routerLinkActive="active" class="full-width">
    <button (click)="onSidenavClose()" class="upercase lr-space bt-links" mat-flat-button [routerLink]="['/buscador']">
      COTIZA UN AUTO
    </button>
  </div>
  <div routerLinkActive="active" class="full-width" *ngIf="!isLoged">
    <button (click)="login()" class="upercase lr-space bt-links" mat-flat-button>
      INICIAR SESIÓN
    </button>
  </div>


  <div class="padd-bt" fxShow.xs="true" *ngIf="router.url.includes('/landing')">
    <div routerLinkActive="active" class="full-width" *ngFor="let section of dataLandingPage">
      <a (click)="onSidenavClose()" [ngClass]="router.url.includes(section.url? section.url : '') ? 'active' : '' "
        class="landing-links upercase lr-space bt-links" mat-flat-button
        href="landing#{{section.url}}">{{section.route | uppercase}}</a>
    </div>
  </div>


  <div class="sidenav-buttons-bot">
    <div class="user-menu full-width bt-links content-btn-logout" *ngIf="isLoged">
      <div *ngIf="processActive && urlLocation === false" class="full-width">
        <button (click)="onSidenavClose()" [class]="getClassCSS()"
          class="btn-process upercase lr-space bt-links border-top" mat-flat-button
          [routerLink]="['/genera-oportunidad']">
          Ir A ÚLTIMO PASO APLICADO
        </button>
      </div>
      <button (click)="onSidenavClose()" class="upercase lr-space bt-links border-top" mat-flat-button
        [routerLink]="['/comparar-unidad']">
        COMPARAR AUTOS
      </button>
      <button class="upercase lr-space bt-links border-top-bot" (click)="logout()" mat-flat-button>
        CERRAR SESIÓN
        <mat-icon class="icon-logout">login</mat-icon>
      </button>
    </div>
  </div>

</mat-nav-list>